export interface ITouchActionX {
  startX: number;
  endX: number;
}

export interface ISliderInfo {
  currentPage: number;
  numberOfPages: number;
}

export const distanceToSlideOnTouchMove = (
  touch: ITouchActionX,
  slider: ISliderInfo,
) => {
  const deltaX = touch.startX - touch.endX;

  const isLastPage = slider.currentPage === slider.numberOfPages;
  const isFirstPage = slider.currentPage === 1;

  const isLastPageBoundary = isLastPage && deltaX > 0;
  const isFirstPageBoundary = isFirstPage && deltaX < 0;

  return !isLastPageBoundary && !isFirstPageBoundary ? deltaX : 0;
};

export const getSlideTouchCheck = (
  touch: ITouchActionX,
  sliderWidth: number,
) => {
  const deltaX = touch.startX - touch.endX;

  const deltaXThreshold = sliderWidth / 4;
  const isNextPageSlideTouch = deltaX > deltaXThreshold;
  const isPreviousPageSlideTouch = deltaX < -deltaXThreshold;
  const isTap = Math.abs(deltaX) < 4;

  return { isNextPageSlideTouch, isPreviousPageSlideTouch, isTap };
};

export const getPagePositionCheck = (slider: ISliderInfo) => {
  const isLastPage = slider.currentPage === slider.numberOfPages;
  const isFirstPage = slider.currentPage === 1;

  return { isLastPage, isFirstPage };
};
